import { Container, Box, Grid } from 'components/box';
import MenuLinks from 'components/menu-links';
import { CmsContentByIdentifier } from 'components/cms-content';

const Privacy = () => (
  <Container>
    <Grid
      gridTemplateColumns={['1fr', null, '1fr 5fr']}
      gridColumnGap={[0, null, 0]}
    >
      <MenuLinks title="Privacy" slug="privacy" />
      <Box>
        <CmsContentByIdentifier identifier="privacy" />
      </Box>
    </Grid>
  </Container>
);

export default Privacy;
